import { render, staticRenderFns } from "./SaveMoney.vue?vue&type=template&id=20fc96ee&scoped=true&"
import script from "./SaveMoney.vue?vue&type=script&lang=ts&"
export * from "./SaveMoney.vue?vue&type=script&lang=ts&"
import style0 from "./SaveMoney.vue?vue&type=style&index=0&id=20fc96ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc96ee",
  null
  
)

export default component.exports